module.exports = __webpack_public_path__ + "static/media/home-changing-6.b75653bf.jpg";